import { RemoteUser, useAgoraRemoteTracks } from "@hireroo/app-helper/livecoding/agora";
import { Widget } from "@hireroo/presentation";

export type GenerateLiveCodingAudioSpeakerPropsArgs = {
  user: RemoteUser;
};

export const useGenerateProps = (props: GenerateLiveCodingAudioSpeakerPropsArgs): Widget.LiveCodingAudioSpeakerProps => {
  const { audioTrack: remoteAudioTrack } = useAgoraRemoteTracks({ remoteUser: props.user });

  return {
    id: props.user.uid.toString(),
    audioTrack: remoteAudioTrack,
  };
};
